const commen = {}


commen.emojiList = [
	{
		url: "jaixin.gif",
		alt: "[爱心]"
	},
	{
		url: "jbaituo.gif",
		alt: "[拜托]"
	},
	{
		url: "jbishi.gif",
		alt: "[鄙视]"
	},
	{
		url: "jbizui.gif",
		alt: "[闭嘴]"
	},
	{
		url: "jchengzan.gif",
		alt: "[称赞]"
	},
	{
		url: "jdaji.gif",
		alt: "[打击]"
	},
	{
		url: "jdaku.gif",
		alt: "[大哭]"
	},
	{
		url: "jdangao.gif",
		alt: "[蛋糕]"
	},
	{
		url: "jdaxiao.gif",
		alt: "[大笑]"
	},
	{
		url: "jfankun.gif",
		alt: "[犯困]"
	},
	{
		url: "jemo.gif",
		alt: "[魔鬼]"
	},
	{
		url: "jfeiwen.gif",
		alt: "[飞吻]"
	},
	{
		url: "jfendou.gif",
		alt: "[奋斗]"
	},
	{
		url: "jfennu.gif",
		alt: "[愤怒]"
	},
	{
		url: "jganbei.gif",
		alt: "[干杯]"
	},
	{
		url: "jgoushou.gif",
		alt: "[勾手]"
	},
	{
		url: "jgouwuche.gif",
		alt: "[购物车]"
	},
	{
		url: "jguilian.gif",
		alt: "[鬼脸]"
	},
	{
		url: "jguzhang.gif",
		alt: "[鼓掌]"
	},{
		url: "jhaixiu.gif",
		alt: "[害羞]"
	},
	{
		url: "jhanxiao.gif",
		alt: "[憨笑]"
	},
	{
		url: "jheixian.gif",
		alt: "[黑线]"
	},
	{
		url: "jhongbao.gif",
		alt: "[红包]"
	},{
		url: "jhuimie.gif",
		alt: "[毁灭]"
	},
	{
		url: "jguilian.gif",
		alt: "[鬼脸]"
	},
	{
		url: "jhuishou.gif",
		alt: "[挥手]"
	},
	{
		url: "jhuizhang.gif",
		alt: "[徽章]"
	},
	{
		url: "jjizhang.gif",
		alt: "[击掌]"
	},
	{
		url: "jkongju.gif",
		alt: "[恐惧]"
	},
	{
		url: "jkoushui.gif",
		alt: "[色]"
	},
	{
		url: "jlazhu.gif",
		alt: "[蜡烛]"
	},
	{
		url: "jliwu.gif",
		alt: "[礼物]"
	},
	{
		url: "jmaohan.gif",
		alt: "[冒汗]"
	},
	{
		url: "jmeiwei.gif",
		alt: "[美味]"
	},
	{
		url: "jmimang.gif",
		alt: "[迷茫]"
	},
	{
		url: "jnanguo.gif",
		alt: "[难过]"
	},
	{
		url: "jok.gif",
		alt: "[OK]"
	},
	{
		url: "joutu.gif",
		alt: "[呕吐]"
	},{
		url: "jqingzhu.gif",
		alt: "[庆祝]"
	},{
		url: "jshangxin.gif",
		alt: "[心碎]"
	},{
		url: "jshengbing.gif",
		alt: "[生病]"
	},
	{
		url: "jshengqi.gif",
		alt: "[生气]"
	},
	{
		url: "jshihua.gif",
		alt: "[石化]"
	},
	{
		url: "jshiluo.gif",
		alt: "[失落]"
	},
	{
		url: "jshuaiku.gif",
		alt: "[酷]"
	},{
		url: "jshuijiao.gif",
		alt: "[睡觉]"
	},{
		url: "jtaiyang.gif",
		alt: "[太阳]"
	},
	{
		url: "jweixiao.gif",
		alt: "[微笑]"
	},
	{
		url: "jwoquan.gif",
		alt: "[握拳]"
	},
	{
		url: "jwoshou.gif",
		alt: "[握手]"
	},{
		url: "jwuzui.gif",
		alt: "[无罪]"
	},
	{
		url: "jxianhua.gif",
		alt: "[玫瑰]"
	},
	{
		url: "jxiaoku.gif",
		alt: "[笑哭]"
	},
	{
		url: "jxuanyun.gif",
		alt: "[眩晕]"
	},
	{
		url: "jye.gif",
		alt: "[胜利]"
	},
	{
		url: "jyiwen.gif",
		alt: "[疑问]"
	},
	{
		url: "jzaijian.gif",
		alt: "[再见]"
	},
	{
		url: "jzhaocai.gif",
		alt: "[招财]"
	},
	{
		url: "jzhishang.gif",
		alt: "[指上]"
	},
	{
		url: "jzhiyou.gif",
		alt: "[指右]"
	},
	{
		url: "jzhuanye.gif",
		alt: "[专业]"
	}
]

/**@dateTimeFliter 转换格林日期时间格式为常用日期格式
 * @time[必填] 						Date  		格林日期格式
 * @part[可选,默认:0]				Number      选择返回日期时间部分  列:0:返回所有 1:只返回日期  2:只返回时间
 * @dateComplete[可选,默认:true] 	Boolean 	日期位数不足是否添0补齐:true:补齐,false:不补齐
 * @timeComplete[可选,默认:true] 	Boolean 	时间位数不足是否添0补齐:true:补齐,false:不补齐
 * @dateConnector[可选,默认:-] 		String 		年月日连接符  例: - : /
 * @timeConnector[可选,默认::] 		String 		时间连接符   例: - : /
 * @hour12[可选,默认:false]          Boolean     是否返回12小时制时间   例: true:返回12小时制时间   false:返回24小时制时间
 * @return   '2019-11-25 15:05:54'  String    返回示例
 * **/
commen.dateTimeFliter = function(time, part = 0, dateComplete = true, timeComplete = true, dateConnector = '-',
	timeConnector = ':', hour12 = false) {
	let year = time.getFullYear()
	let month = time.getMonth() + 1
	let day = time.getDate()
	let hour = time.getHours()
	let minute = time.getMinutes()
	let second = time.getSeconds()
	let dateStr = ''
	let timeStr = ''
	//转换日期
	if (dateComplete) { //添0补齐
		if (month < 10) {
			month = '0' + month
		}
		if (day < 10) {
			day = '0' + day
		}
	}
	dateStr = year + dateConnector + month + dateConnector + day
	//转换时间
	//修改小时制
	if (hour12) {
		if (hour > 12) {
			hour = hour - 12
			if (timeComplete) {
				if (hour < 10) {
					hour = '下午 ' + '0' + hour
				} else {
					hour = '下午 ' + hour
				}
			}
		} else {
			if (timeComplete) {
				if (hour < 10) {
					hour = '上午 ' + '0' + hour
				} else {
					hour = '上午 ' + hour
				}
			}
		}
	}
	//判断分钟与秒
	if (timeComplete) { //添0补齐
		if (minute < 10) {
			minute = '0' + minute
		}
		if (second < 10) {
			second = '0' + second
		}
	}
	timeStr = hour + timeConnector + minute + timeConnector + second
	//合成输出值
	if (part == 0) {
		return dateStr + ' ' + timeStr
	} else if (part == 1) {
		return dateStr
	} else if (part == 2) {
		return timeStr
	}
	return '传参有误'
}



export default commen
